import { defineStore } from 'pinia';
import type { ComplementarySidebarState } from '~~/types/vuex/ComplementarySidebar';

export const complementarySidebarStore = defineStore('complementarySidebar', {
  state: () => ({ isComplementarySidebarOpen: false as ComplementarySidebarState['isComplementarySidebarOpen'] | null }),
  actions: {
    setIsComplementarySidebarOpen(payload: ComplementarySidebarState['isComplementarySidebarOpen'] | null) {

      this.isComplementarySidebarOpen = payload; 

    },
  },
});
